import { Directive, Injector, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { AreasRegistryContext } from './areas-registry-context';
import { AREAS_REGISTRY, AreasRegistry } from './areas.service';


@Directive({
    selector: '[ftAreas]',
    standalone: false
})
export class AreasDirective implements OnInit {

    static DEFAULT_AREAS_REGISTRY = AREAS_REGISTRY;

    @Input()
    ftAreasRegistryName: string | undefined;


    context: AreasRegistryContext;

    // WS5 #10 Stage B B5b: the eager `this.injector.get("$injector")` grab is GONE — it
    // was the only AngularJS tie in the nav-chrome directive (it blocked the menu from
    // instantiating once AngularJS stops booting). The registry tokens
    // ('AreasRegistry'/'AppMenuAreasRegistry') are resolved below via the ANGULAR injector
    // (native string-token providers, app.module.ts:252/254), not `$injector`.
    constructor(private injector: Injector,
                private router: UIRouter,
                private templateRef: TemplateRef<AreasRegistryContext>,
                private viewContainerRef: ViewContainerRef) {
    }

    ngOnInit() {
        this.setupRegistry(this.ftAreasRegistryName || AreasDirective.DEFAULT_AREAS_REGISTRY);
    }

    setupRegistry(registryService: string) {
        const registry = this.injector.get(registryService) as AreasRegistry;
        if (!!registry) {
            this.context = new AreasRegistryContext(registry, this.router);
            this.viewContainerRef.createEmbeddedView(this.templateRef, this.context);
        }
    }

}
